import type { ComponentPropsWithRef, ComponentType } from 'react';
import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import type { ProjectKey } from '@atlassian/jira-shared-types/src/general.tsx';
import type { BoardId } from '@atlassian/jira-software-roadmap-model/src/app/index.tsx';
import {
	isClassic as getIsClassic,
	getBoardId,
	getCloudId,
} from '../../../state/app/selectors.tsx';
import {
	getIsSprintsFeatureEnabled,
	getIsUserBoardAdmin,
	getProjectKey,
	hasAdministerProjectPermission,
} from '../../../state/configuration/selectors.tsx';
import { exportCsv } from '../../../state/ui/share/actions.tsx';
import type { State } from '../../../state/types.tsx';
import JpdRoadmapButton from '../jpd-roadmap/button/index.tsx';
import type ShareModal from './share-modal-with-analytics/share-modal/async.tsx';
import ShareModalWithAnalytics from './share-modal-with-analytics/index.tsx';
import MoreSettings from './view.tsx';

type StateProps = {
	isCMP: boolean;
	boardId: BoardId;
	projectKey: ProjectKey;
	cloudId: string;
	boardType: string;
	canConfigureTimeline: boolean;
	ExportImageModal: ComponentType<ComponentPropsWithRef<typeof ShareModal>>;
	JpdRoadmapButton?: ComponentType<{}>; // GALILEO-1454
};

export default connect(
	(state: State): StateProps => ({
		isCMP: getIsClassic(state),
		boardId: getBoardId(state),
		projectKey: getProjectKey(state),
		cloudId: getCloudId(state) ?? '',
		boardType: getIsSprintsFeatureEnabled(state) ? 'Scrum' : 'Kanban',
		canConfigureTimeline: hasAdministerProjectPermission(state) || getIsUserBoardAdmin(state),
		ExportImageModal: ShareModalWithAnalytics,
		JpdRoadmapButton, // GALILEO-1454
	}),
	{
		onExportCsv: exportCsv,
	},
)(MoreSettings);
